import React from 'react';

const NavButton1 = ({ title }) => {

    const handleClick = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <button id="nav-button" className="h-full flex justify-center items-top border-red-500 border-b-4 transition-all ease-linear transition-100 cursor-pointer" onClick={() => handleClick()}>
            <p className="text-red-500 josefin-500 text-l m-0 pt-7">{title}</p>
        </button>
    );
}

export default NavButton1;
